import React, {useState, useEffect} from "react";
import {Routes, Route, Navigate, Outlet, useNavigate} from "react-router-dom";
import IUser from "./types/user.type";
import logo from './logo.svg';
import ProtectedRoute from "./components/Utils/ProtectedRoute";
import PublicRoute from "./components/Utils/PublicRoute";
import ActivityTracker from "./components/Utils/ActivityTracker";

import './App.css';

import Home from "./components/Home/Home";
import Navbar from "./components/Navbar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";

import Login from "./components/Login/Login";

import StationList from "./components/Station/Station";
import Ticket from "./components/Ticket/Ticket";

import StationTimeSeries from "./components/StationIssue/StationTimeSeries";
import VariableTimeSeries from "./components/TimeSeriesChart/VariableTimeSeries";

import ViewStation from "./components/Station/View";
import ActivityTimeline from "./components/Activity/ActivityTimeline";

import {AuthProvider} from "./contexts/AuthContext";


type Props = {};

const Layout = ({children}: { children: React.ReactNode }) => (
    <div className="wrapper">
        <div>
            <Navbar/>
            <Sidebar/>
        </div>
        <ActivityTracker />
        {children}
    </div>
);


const App: React.FC = () => {

    const [loggedIn, setLoggedIn] = useState(false)
     const navigate = useNavigate();

    useEffect(() => {
        // Make navigate available globally for axios interceptor
        (window as any).__navigate = navigate;

        // Clean up on unmount
        return () => {
            delete (window as any).__navigate;
        };
    }, [navigate]);



    return (
        <AuthProvider>
            <Routes>
                {/* Public route with redirect if already logged in */}
                <Route
                    path="/login"
                    element={
                        <PublicRoute>
                            <Login/>
                        </PublicRoute>
                    }
                />


                {/* Protected routes */}
                <Route element={
                    <ProtectedRoute>
                        <Layout>
                            <Outlet/>
                        </Layout>
                    </ProtectedRoute>
                }>
                    <Route index element={<Home/>}/>
                    <Route path="stations">
                        <Route index element={<StationList/>}/>
                        <Route path="flagged" element={<StationList/>}/>
                        <Route path="country/:code" element={<StationList/>}/>
                        <Route path="status/:status" element={<StationList/>}/>
                        <Route path=":stationCode" element={<ViewStation/>}/>
                        <Route path=":stationCode/timeseries/:category" element={<StationTimeSeries />}/>
                        <Route path=":stationCode/variable/:variable" element={<VariableTimeSeries />}/>

                    </Route>
                    <Route path="tickets">
                        <Route index element={<Ticket/>}/>
                        <Route path="status/:status" element={<Ticket/>}/>
                        <Route path="label/:label" element={<Ticket/>}/>
                    </Route>
                    <Route path="activities" element={<ActivityTimeline/>}/>
                </Route>

                {/* Catch all other routes and redirect to home */}
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Routes>

        </AuthProvider>

    );
};

export default App;
